'use client';

import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import type { Conversation } from '../../types/agent.types';

interface ConversationListItemProps {
  conversation: Conversation;
  isActive: boolean;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
}

export default function ConversationListItem({
  conversation,
  isActive,
  onSelect,
  onDelete,
}: ConversationListItemProps) {
  const formattedDate = new Date(conversation.updatedAt).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });

  return (
    <Box
      onClick={() => onSelect(conversation.conversationId)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        p: '0.625rem 0.75rem',
        borderRadius: '8px',
        cursor: 'pointer',
        bgcolor: isActive ? 'rgba(71, 225, 188, 0.08)' : 'transparent',
        '&:hover': {
          bgcolor: isActive ? 'rgba(71, 225, 188, 0.12)' : 'rgba(244, 246, 255, 0.04)',
        },
      }}
    >
      <ChatBubbleOutlineIcon
        sx={{ fontSize: '1rem', color: 'var(--sw-white-color-90)', flexShrink: 0 }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="body2"
          noWrap
          sx={{
            color: 'var(--sw-white-color)',
            fontSize: '0.8rem',
            fontWeight: isActive ? 600 : 400,
          }}
        >
          {conversation.title}
        </Typography>
        <Typography variant="caption" sx={{ color: 'var(--sw-white-color-90)', opacity: 0.6 }}>
          {formattedDate} &middot; {conversation.messageCount} messages
        </Typography>
      </Box>
      <IconButton
        size="small"
        onClick={e => {
          e.stopPropagation();
          onDelete(conversation.conversationId);
        }}
        sx={{
          color: 'var(--sw-white-color-90)',
          opacity: 0,
          p: '4px',
          '.MuiBox-root:hover > &': { opacity: 0.5 },
          '&:hover': { opacity: 1, color: '#d0342c' },
        }}
      >
        <DeleteOutlineIcon sx={{ fontSize: '1rem' }} />
      </IconButton>
    </Box>
  );
}
